module.exports = __webpack_public_path__ + "img/L3_zoom.a93a97ab.svg";